import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../components/componentsStyles/Docs.module.css'
import Content from '../components/docsComponents/Content';
import Larea from '../components/docsComponents/Larea';
const Docs = () => {
  return (
    <div className={styles.docPage}>
      <div className={styles.horizontalScroll}></div>
      
      <div className={styles.content}>

        <div className={styles.larea}>
          <Larea/>
        </div>


        <div className={styles.textContent}>
          <div className={styles.intro}>
            <h3> First time building a web site? Or just wont to know more about the options for your project?</h3>
            <p> Explore the themes bellow, also fell free to ask anything <Link to ='/'>on the contact form. </Link></p>
          </div>

          <div className={styles.contentSectio}>
            <Content/>
          </div>

        </div>

      
      </div>
      
    </div>
  )
}

export default Docs